import { render, staticRenderFns } from "./sifatSurat.vue?vue&type=template&id=9a9d3ea6&"
import script from "./sifatSurat.vue?vue&type=script&lang=js&"
export * from "./sifatSurat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QSeparator,QBtnGroup,QTooltip,QPagination,QDialog,QIcon,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QSeparator,QBtnGroup,QTooltip,QPagination,QDialog,QIcon,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
